<template lang="html">
  <v-dialog
    v-model="opened"
    max-width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @keydown.esc="$emit('update:opened', false)"
    lazy
  >
    <v-card>
      <v-card-title class="title pb-0">
        Manage Tags
        <v-spacer />

        <v-btn
          fab
          small
          class="error--text text-none my-0"
          flat
          @click="$emit('update:opened', false)"
        >
          <v-icon>clear</v-icon>
        </v-btn>
      </v-card-title>

      <v-tabs
        :value="tagType"
        @change="$emit('update:tagType', $event)"
        class="px-3 tabs"
      >
        <v-tab
          v-if="currentUser.overview_setting.use_contact_tags"
          key="client-tags"
          href="#client-tags"
          >Client tags</v-tab
        >
        <v-tab
          v-if="currentUser.overview_setting.use_entity_tags"
          key="entity-tags"
          href="#entity-tags"
          >Entity tags</v-tab
        >
      </v-tabs>

      <v-tabs-items :value="tagType" @change="$emit('update:tagType', $event)">
        <v-tab-item value="client-tags">
          <v-card-text class="text-xs-left">
            <v-layout wrap>
              <span v-if="isEmpty(firmContactTags)" class="my-2 grey--text ml-2"
                >None</span
              >
              <v-chip
                v-else
                small
                align-center
                v-for="(tag, i) in firmContactTags"
                :key="i"
                >{{ tag.name
                }}<v-icon
                  @click="removeClientTag(tag.id, i)"
                  class="ml-2"
                  size="15"
                  style="cursor: pointer"
                  >clear</v-icon
                ></v-chip
              >
            </v-layout>
            <v-divider class="my-4" />
            <v-layout align-center>
              <v-text-field
                v-model="newTag"
                hide-details
                class="default-input"
                solo
                placeholder="New Tag Name"
              />
              <v-btn
                class="primary text-none"
                @click="addClientTag()"
                :disabled="isEmpty(newTag)"
              >
                Add Tag
              </v-btn>
            </v-layout>
          </v-card-text>
        </v-tab-item>

        <v-tab-item value="entity-tags">
          <v-card-text class="text-xs-left">
            <v-layout wrap>
              <span v-if="isEmpty(firmEntityTags)" class="my-2 grey--text ml-2"
                >None</span
              >
              <v-chip
                v-else
                small
                align-center
                v-for="(tag, i) in firmEntityTags"
                :key="i"
                >{{ tag.name
                }}<v-icon
                  @click="removeEntityTag(tag.id, i)"
                  class="ml-2"
                  size="15"
                  style="cursor: pointer"
                  >clear</v-icon
                ></v-chip
              >
            </v-layout>
            <v-divider class="my-4" />
            <v-layout align-center>
              <v-text-field
                v-model="newTag"
                hide-details
                class="default-input"
                solo
                placeholder="New Tag Name"
              />
              <v-btn
                class="primary text-none"
                @click="addEntityTag()"
                :disabled="isEmpty(newTag)"
              >
                Add Tag
              </v-btn>
            </v-layout>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import API from '@/api';
import { mapState, mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import take from 'lodash/take';
import get from 'lodash/get';

export default {
  name: 'ManageTagsDialog',
  data() {
    return {
      newTag: '',
    };
  },
  props: {
    opened: {
      type: Boolean,
    },

    tagType: {
      type: String,
    },
  },
  computed: {
    ...mapGetters(['isAdvisor']),
    ...mapGetters({
      currentUser: 'user',
      currentUserFirm: 'currentFirm',
    }),
    firmContactTags() {
      if (this.currentUserFirm) {
        return this.currentUserFirm.contact_tags;
      } else {
        return [];
      }
    },
    firmEntityTags() {
      if (this.currentUserFirm) {
        return this.currentUserFirm.entity_tags;
      } else {
        return [];
      }
    },
  },
  methods: {
    moment,
    isEmpty,

    async addClientTag() {
      if (this.currentUserFirm.contact_tags.includes(this.newTag)) {
        this.$store.dispatch('application/setErrorNotification', {
          message: 'Tag already exists',
        });
        return;
      }
      try {
        const response = await API.firm.addClientTag(this.newTag);
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Tag created!',
          });
          this.$emit('refresh-firm');
          this.$store.dispatch('setCurrentFirm');
        }
        this.newTag = '';
      } catch (e) {
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'There was a problem adding the tag. Please try again after refreshing the page.',
        });
      }
    },

    async removeClientTag(id, index) {
      try {
        const response = await API.firm.removeClientTag(id);
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Tag deleted!',
          });
          this.currentUserFirm.contact_tags.splice(index, 1);
        }
        this.newTag = '';
      } catch (e) {
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'There was a problem adding the tag. Please try again after refreshing the page.',
        });
      }
    },

    async addEntityTag() {
      if (this.currentUserFirm.entity_tags.includes(this.newTag)) {
        this.$store.dispatch('application/setErrorNotification', {
          message: 'Tag already exists',
        });
        return;
      }
      try {
        const response = await API.firm.addEntityTag(this.newTag);
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Tag created!',
          });
          this.$emit('refresh-firm');
          this.$store.dispatch('setCurrentFirm');
        }
        this.newTag = '';
      } catch (e) {
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'There was a problem adding the tag. Please try again after refreshing the page.',
        });
      }
    },

    async removeEntityTag(id, index) {
      try {
        const response = await API.firm.removeEntityTag(id);
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Tag deleted!',
          });
          this.currentUserFirm.entity_tags.splice(index, 1);
        }
        this.newTag = '';
      } catch (e) {
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'There was a problem adding the tag. Please try again after refreshing the page.',
        });
      }
    },
  },
};
</script>

<style lang="postcss" scoped>
.tabs {
  border-bottom: 1px solid #ddd;
}
</style>
